import React from 'react';
import { useRouter } from 'next/router';
import TestimonialPageTemplate from './template';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { SEO } from '../../../utils/SEO';
import { Testimony } from '../../../types/schema';

type TechnologyPageTemplateProps = {
  language?: string;
  testimonies: Testimony[];
};

const TechnologyPageComponent: React.FC<TechnologyPageTemplateProps> = ({
  language,
  testimonies,
}) => {
  const isEn = language === 'en';
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000/';
  const router = useRouter();

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: siteUrl,
    },
    {
      position: 2,
      name: `${isEn ? 'Testimonials' : 'Depoimentos'} - App Masters - ${
        isEn ? 'Brazil' : 'Juiz de Fora/MG'
      }`,
      item: `${siteUrl}${language}/${isEn ? 'testimonials' : 'depoimentos'}`,
    },
  ];

  const additionalLinkTags = [
    {
      rel: 'alternate',
      href: siteUrl + `pt/depoimentos`,
      hrefLang: 'pt',
    },
    {
      rel: 'alternate',
      href: siteUrl + `en/testimonials`,
      hrefLang: 'en',
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: language as string,
          title: isEn ? 'Testimonials' : 'Depoimentos',
          defaultTitle: {
            enTitle: 'Testimonials',
            ptTitle: 'Depoimentos',
          },
          description: isEn ? 'Testimonials' : 'Depoimentos',
        })}
        additionalLinkTags={additionalLinkTags}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <TestimonialPageTemplate
        language={language as string}
        testimonies={testimonies as Testimony[]}
      />
    </>
  );
};

export default TechnologyPageComponent;
